import React, { FC, memo, useState } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { toast } from '@shared/ui';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import { usePointUpdateMutation } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Input, { InputType } from '@zvuk-b2b/react-uikit/ui/Input';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const PointChangeCommentModal: FC<ModalProps[ModalTypes.POINT_CHANGE_COMMENT]> = ({
  pointId,
  comment: initialComment,
  close,
}) => {
  const [mutate, mutationResult] = usePointUpdateMutation({
    refetchQueries: ['point', 'pointList'],
  });

  const [comment, setComment] = useState<string>(initialComment || '');

  const onSave = async () => {
    if (pointId) {
      try {
        const ok = await mutate({ variables: { input: { pointId, comment } } });

        if (ok) {
          close();

          toast.info(TEXTS.NOTIFICATION_SUCCESS_TEXT);
        } else {
          toast.error(DEFAULT_ERROR_MESSAGE);
        }
      } catch (e: unknown) {
        const error = e as Error;

        if (/value too long/.test(error.message)) {
          toast.error(TEXTS.NOTIFICATION_ERROR_TOO_LONG_TEXT);
        }
      }
    }
  };

  return (
    <ModalScreen
      title={TEXTS.TITLE}
      titlePlacement="left"
      onClose={close}
      className={styles.description}
      actionButtons={[
        <Button
          key="button_change_comment_point_modal"
          elementId="button_change_comment_point_modal"
          type={ButtonType.PRIMARY}
          isLoading={mutationResult.loading}
          isDisabled={comment === initialComment}
          onClick={onSave}>
          {TEXTS.SAVE_BUTTON_TEXT}
        </Button>,
      ]}>
      <Input
        elementId="button_change_comment_input"
        type={InputType.TEXT}
        containerClassName={styles.input}
        value={comment}
        isDisabled={mutationResult.loading}
        placeholder={TEXTS.INPUT_PLACEHOLDER}
        onChange={setComment}
      />
    </ModalScreen>
  );
};

export default memo(PointChangeCommentModal);
